// extracted by mini-css-extract-plugin
module.exports = {"transparent":"loader_transparent__1rs80","imgSpin":"loader_imgSpin__Xf8Tq","noTransparent":"loader_noTransparent__20t0w"};